import rpc from '@square/dashboard-utilities/clients/rpc';
import { FulfillmentConfigurationService } from '@square/dashboard-protos/models/squareup/channelcontrols/configuration/service';
export default FulfillmentConfigurationService.create(rpc());